module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_3016.73865865.png";